export const KEY = {
    confirmEmailService:'service_114n3wy',
    confirmEmailTemplate:'template_mt7ytaj',
    apiKey:'t9mWr1CRiWH6FZgDy',
    locationUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1939.676906043426!2d9.98959981678594!3d45.89047710752064!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4783dd7e6c396b17%3A0xcb0ba166840cd8bb!2sHotel%20Libia!5e0!3m2!1sit!2sit!4v1726577620407!5m2!1sit!2sit'
}